import { useState } from "react";
import { Toaster } from "sonner";
import Header from "@/components/bulbit/Header";
import Hero from "@/components/bulbit/Hero";
import About from "@/components/bulbit/About";
import ServicesMarquee from "@/components/bulbit/ServicesMarquee";
import Prices from "@/components/bulbit/Prices";
import Clients from "@/components/bulbit/Clients";
import Contact from "@/components/bulbit/Contact";
import Footer from "@/components/bulbit/Footer";

export default function Landing() {
  const [plan, setPlan] = useState("Контент");

  return (
    <div>
      <Toaster position="top-center" richColors />
      <Header />
      <main className="relative z-10">
        <Hero />
        <About />
        <ServicesMarquee />
        <Prices onSelectPlan={setPlan} />
        <Clients />
        <Contact interest={plan} onInterestChange={setPlan} />
      </main>
      <Footer />
    </div>
  );
}
